
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

interface UpdatePaymentData {
  amount: number;
  paymentDate?: string;
  notes?: string;
}

export const useUpdateClientPayment = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async ({
      paymentId,
      paymentData
    }: {
      paymentId: string;
      paymentData: UpdatePaymentData;
    }) => {
      console.log('Updating payment:', paymentId, paymentData);

      // Use RPC function - TypeScript doesn't know about it yet but it exists
      const { data: payment, error: paymentError } = await supabase
        .rpc('update_client_payment' as any, {
          p_payment_id: paymentId,
          p_amount: paymentData.amount,
          p_payment_date: paymentData.paymentDate || new Date().toISOString().split('T')[0],
          p_notes: paymentData.notes
        });

      if (paymentError) {
        console.error('Error updating payment:', paymentError);
        throw paymentError;
      }

      return payment;
    },
    onSuccess: (data) => {
      console.log('Payment updated successfully, invalidating all related queries...');
      // Invalidate all payment-related queries
      queryClient.invalidateQueries({ queryKey: ['clientPayments'] });
      queryClient.invalidateQueries({ queryKey: ['subscriptionPayments'] });
      // Invalidate client queries to refresh payment status
      queryClient.invalidateQueries({ queryKey: ['clients'] });
      queryClient.invalidateQueries({ queryKey: ['client'] });
      toast.success('Payment updated successfully');
    },
    onError: (error) => {
      console.error('Error in update payment mutation:', error);
      toast.error('Failed to update payment');
    }
  });
};
